  <h2 mat-dialog-title>Manage Account</h2>
    
  <mat-dialog-content>
    <div class="dialog-content-container">
        @if (!deletionSectionVisible) {
          <p>You have {{ getDaysRemaining() }} days remaining to submit this assessment. Click Continue to proceed</p>
        }

        @if (deletionSectionVisible) {
          @if (!isBusy && !isDeleted) {
            <p>Are you sure you want to delete the assessment?</p>
            
          
                <app-password-input
                  [label]="'Password'" 
                  shortLabel="Password"
                  [control]="dialogForm.controls.password"
                  [errorMsg]="'Please enter your password to confirm deletion'">
                  </app-password-input>
           
      
          }

          @if (hasError) {
             <div class="error-container">
              <mat-error>
                  An error occurred deleting your assessment, please check your connection or credentials.
                </mat-error>
           </div>
      
          }

          @if (isDeleted) {
            <div class="success-container">
              <mat-icon class="success-icon">check_circle</mat-icon>
              <p>Your assessment has been deleted</p>
            </div>
          }

          @if (isBusy) {
            <div class="loading-container">
              <mat-spinner diameter="60"></mat-spinner>
              <p>Deleting your assessment...</p>
            </div>
          }
        }
      </div>  
    </mat-dialog-content>
 @if (!deletionSectionVisible) {
<mat-dialog-actions align="end">
     <button mat-flat-button class="delete-button" type="button" (click)="showDeletionSection()">Delete</button>
    <button mat-flat-button mat-dialog-close type="button">Continue</button>
</mat-dialog-actions>
 }
  @if (deletionSectionVisible && !isBusy && !isDeleted) {
    <mat-dialog-actions align="end">
    <button mat-flat-button class="delete-button" type="button" [disabled]="dialogForm.invalid" (click)="deleteForm()">Delete</button>
    <button mat-flat-button mat-dialog-close type="button">Cancel</button>
    </mat-dialog-actions>
  }
